import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PetitionHourCompensationPage } from './petition-hour-compensation';

@NgModule({
  declarations: [
    PetitionHourCompensationPage,
  ],
  imports: [
    IonicPageModule.forChild(PetitionHourCompensationPage),
  ],
})
export class PetitionHourCompensationPageModule {}



// WEBPACK FOOTER //
// ./src/pages/petition-hour-compensation/petition-hour-compensation.module.ts